import { render, staticRenderFns } from "./selectedItem.vue?vue&type=template&id=d44e4e1e"
import script from "./selectedItem.vue?vue&type=script&lang=js"
export * from "./selectedItem.vue?vue&type=script&lang=js"
import style0 from "./selectedItem.vue?vue&type=style&index=0&id=d44e4e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports